exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ClimbAnimation-56163cd0{display:flex;border:1px solid #b3b3b3;border-radius:5px;height:200px;overflow:hidden}.ClimbAnimationPaused-2f1e6e91{opacity:0.75}.left-fef8720f{flex:5}.right-73f739ad{flex:3;border-left:1px solid #b3b3b3}@media screen and (max-width: 500px){.right-73f739ad{max-width:75px;min-width:75px}}\n", ""]);

// Exports
exports.locals = {
	"ClimbAnimation": "ClimbAnimation-56163cd0",
	"ClimbAnimationPaused": "ClimbAnimationPaused-2f1e6e91",
	"left": "left-fef8720f",
	"right": "right-73f739ad"
};